import { Navigate } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { useGetResolvedFlagsQuery } from '../../../store/api/featureFlagsApi';
import { useEffectiveTenant } from '../../../hooks/useEffectiveTenant';

/**
 * La puerta de las rutas /agente/*. Imperium entra por `phylax_crm`, como siempre; una
 * inmobiliaria de Booster, por `phylax-marketplace` (con o sin suscripción: sin ella,
 * PhylaxShell muestra la página de venta en lugar de la pantalla). (22/10/2026)
 */
export function PhylaxGuard({ children }: { children: React.ReactNode }) {
  const { data, isLoading } = useGetResolvedFlagsQuery();
  const { tenantMode } = useEffectiveTenant();
  if (isLoading || !data) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '60vh' }}>
        <CircularProgress />
      </Box>
    );
  }
  const imperium = !('phylax_crm' in data) || data.phylax_crm !== false;
  const booster = tenantMode === 'booster' && data['phylax-marketplace'] === true;
  if (tenantMode === 'booster' ? !booster : !imperium) return <Navigate to="/dashboard" replace />;
  return <>{children}</>;
}
